module.exports = __webpack_public_path__ + "img/good.a1c28551.svg";